module.exports = __webpack_public_path__ + "img/new_index_cases17.0b961a78.png";